export const SITE_ARTICLES_GRID_NAME = 'SiteArticlesGrid';

export const SITE_ARTICLE_VISIBILITY__ALL = 'ALL';
export const SITE_ARTICLE_VISIBILITY__BOYS = 'BOYS';
export const SITE_ARTICLE_VISIBILITY__GIRLS = 'GIRLS';
export const SITE_ARTICLE_VISIBILITY__UNLOGGED = 'UNLOGGED';

export const siteArticleVisibilities = [
  SITE_ARTICLE_VISIBILITY__ALL,
  SITE_ARTICLE_VISIBILITY__UNLOGGED,
  SITE_ARTICLE_VISIBILITY__GIRLS,
  SITE_ARTICLE_VISIBILITY__BOYS,
];

export const siteArticleVisibilityLangKeys = {
  [SITE_ARTICLE_VISIBILITY__ALL]: 'msg.visibility.all',
  [SITE_ARTICLE_VISIBILITY__UNLOGGED]: 'msg.visibility.unlogged',
  [SITE_ARTICLE_VISIBILITY__GIRLS]: 'msg.visibility.girls',
  [SITE_ARTICLE_VISIBILITY__BOYS]: 'msg.visibility.boys',
};

export const SITE_ARTICLE_STATUS__APPROVED = 'APPROVED';
export const SITE_ARTICLE_STATUS__DECLINED = 'DECLINED';
export const SITE_ARTICLE_STATUS__PENDING = 'PENDING';

export const siteArticleStatuses = [
  SITE_ARTICLE_STATUS__APPROVED,
  SITE_ARTICLE_STATUS__DECLINED,
  SITE_ARTICLE_STATUS__PENDING,
];

export const siteArticleStatusLangKeys = {
  [SITE_ARTICLE_STATUS__APPROVED]: 'msg.approved',
  [SITE_ARTICLE_STATUS__DECLINED]: 'msg.canceled',
  [SITE_ARTICLE_STATUS__PENDING]: 'msg.pending',
};
